// Preselects subscription or one-time purchase from the URL, e.g.
// /products/original-house-blend?variant=123&purchase=onetime (or purchase=sub).
// Clicking the radio (instead of setting .checked) runs the existing purchase-type
// handlers so prices, selling plan inputs and active cards stay in sync.
// Keys are the URL values; values must match the buy_type radio values in the theme.
document.addEventListener("DOMContentLoaded", function () {
  var purchase = new URLSearchParams(window.location.search).get("purchase");
  var buyTypes = { subscription: "subscription", onetime: "oneoff" };
  var buyType = purchase && buyTypes[purchase.toLowerCase()];
  if (!buyType) return;

  document.querySelectorAll('input[name="buy_type"][value="' + buyType + '"]').forEach(function (input) {
    if (!input.checked) input.click();
  });
});
